export default __webpack_public_path__ + "static/media/IMG_3020.bae5f682.JPG";